import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const ollama = defineConnector({
  identifier: "ollama",
  name: "Ollama",
  tagLine: "Local large language models",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: ({ domain }) =>
    domainToRegex(domain).replace(/^https/, "http"),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Configure your Ollama instance",
      items: [
        {
          kind: "markdown",
          content:
            "If your Ollama instance requires an API key, enter it below along with the domain where Ollama is running.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Domain",
          placeholder: "localhost:11434",
          required: true,
          target: { kind: "configuration", field: "domain" },
          helperText: "The host and port of your Ollama instance.",
        },
        {
          kind: "input",
          label: "API key",
          required: false,
          target: { kind: "secrets", field: "apiKey" },
          helperText:
            "Optional. Only required if your instance is behind an auth proxy.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `http://${domain}/api/tags`,
  },
});
